export default __webpack_public_path__ + "static/media/pe200u.e46999bb.png";